import React, { useEffect, useState } from "react";
import Popup from "../Popup";
import FormHeader from "../form/Header";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/formatDate";
import { GetOrderDetail } from "../../api/orders/getOrderDetail";
import { LoadingIcon } from "../../assets/icons/Icons";

const ViewOrder = ({ order, onClose, ...props }) => {
  const { t } = useTranslation();
  const [orderDetail, setOrderDetail] = useState(null);
  const [loading, setloading] = useState(false);
  const fetchOrder = async (id) => {
    setloading(true);
    try {
      const orderDetails = await GetOrderDetail(order.id);
      setOrderDetail(orderDetails?.id ? orderDetails : null);
    } catch (error) {
      console.log(error);
    }
    setloading(false);
  };
  useEffect(() => {
    if (order?.id && !orderDetail) {
      fetchOrder(order?.id);
    }
    return () => {
      setOrderDetail(null);
      setloading(false);
    };
    // eslint-disable-next-line
  }, [order]);
  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <FormHeader title={`Order ID: ${order?.id}`}></FormHeader>

      <div className="mt-5">
        <table className="table">
          <tbody>
            <tr>
              <td>{t("Company ID")}:</td>
              <td>
                <strong>{order?.company_id}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Order Date")}:</td>
              <td>
                <strong>{formatDate(order?.created_at)}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Created by")}:</td>
              <td>
                <strong>{order?.created_by}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Description")}:</td>
              <td>
                <strong>{order?.description}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("External Tag")}:</td>
              <td>
                <strong>{order?.external_tag}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Office ID")}:</td>
              <td>
                <strong>{order?.office_id}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Package Code")}:</td>
              <td>
                <strong>{order?.package_code}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Program ID")}:</td>
              <td>
                <strong>{order?.program_id}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Quantity")}:</td>
              <td>
                <strong>{order?.quantity}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Shipping ID")}:</td>
              <td>
                <strong>{order?.shipping_address_id}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Tracking ID")}:</td>
              <td>
                {loading ? (
                  <div style={{ width: "20px", height: "20px" }}>
                    <LoadingIcon />
                  </div>
                ) : (
                  <strong>
                    {loading
                      ? "Fetching Tracking ID..."
                      : orderDetail?.tracking_number ?? "Tracking unavailable."}
                  </strong>
                )}
              </td>
            </tr>
            <tr>
              <td>{t("Status")}:</td>
              <td>
                <strong>{order?.status}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Updated At")}:</td>
              <td>
                <strong>{formatDate(order?.updated_at)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Popup>
  );
};

export default ViewOrder;
